import { useEffect, useState } from "react";
import { ArrowUpWhiteIcon } from "../../assets/icons";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <button
      onClick={scrollToTop}
      className={`scroll-to-top-btn ${isVisible ? "scroll-to-top-btn-visible" : ""}`}
    >
      <ArrowUpWhiteIcon />
    </button>
  );
};

export default ScrollToTopButton;
